import { useMutation, useQueryClient } from "@tanstack/react-query"

import mentorCloudService from "src/service/mentor-cloud-service"
import queries from "src/queries"

import useToast from "../useToast"

import { MentorCloudFileFilters } from "src/types/files/file"

export const useMentorCloudRenameFolder = (
    filters: MentorCloudFileFilters = { search: '', order: { column: 'name', ascending: true }, type: '*' },
    parentFolderId: number | null = null) => {
    const { notify } = useToast()

    const queryClient = useQueryClient()

    const { mutateAsync: renameFolder, isPending } = useMutation({
        mutationFn: mentorCloudService.renameFolder,
        onSuccess: async () => {
            notify('FOLDER.rename')

            await queryClient.invalidateQueries({
                queryKey:
                    parentFolderId && parentFolderId !== null
                        ? queries.mentorCloud.folder(parentFolderId).queryKey
                        : queries.mentorCloud.all.queryKey
            })
            await queryClient.invalidateQueries({
                queryKey: queries.mentorCloud.files(parentFolderId || null, filters).queryKey
            })
        },
        onError: () => notify('FOLDER.rename', { type: 'error' })
    })

    return { renameFolder, isPending }
}